import parse from 'html-react-parser';
import { FC } from 'react';
import style from './connectorTermStyle.module.css';
import { RoundSheet } from '@/components/uiParts/Sheet/RoundSheet/RoundSheet';

interface ConnectorTermProps {
  html?: string;
}

export const ConnectorTerm: FC<ConnectorTermProps> = ({ html }) => {
  if (!html) return <></>;
  return (
    <RoundSheet>
      <div className={style['container']}>{parse(html)}</div>
    </RoundSheet>
  );
};
